import Backbone from "backbone";
import {isFnacPro} from "../others/Configuration";
import $ from "jquery";

// � � � � � � � � � � � � � � � � � � � � � � � �
  // TODO : why the HTML is in this JS file !!! Put it in a template or in the view or gods will kill a baby cat !!!

  var contentCom = "<div class='tooltipFnacPlus-container'><a class='tooltipFnacPlus-link' href='https://www.fnac.com/choisir-carte' title='En savoir plus'><img src='https://static.fnac-static.com/multimedia/fnacdirect/publi/popin-fnacplus.png'></a></div>";
  var contentPro = "<div class='tooltipFnacPlus-container'><a class='tooltipFnacPlus-link' href='https://www.fnacpro.com/carte-adherent' title='En savoir plus'><img src='https://static.fnac-static.com/multimedia/fnacdirect/publi/popin-fnacpluspro.png'></a></div>";

export default Backbone.View.extend({
    initialize: function () {
      this.isLoaded = false;
      this.isActive = false;

      this.initContent();
    },

    events: {
      "click .js-searchFnacPlus-show": "showContent",
      "mouseover .js-searchFnacPlus-container": "showContent",
      "mouseout .js-searchFnacPlus-container": "removeContent",
      // end
    },

    initContent: function () {
      this.$fnacPlusContainer = this.$(".js-searchFnacPlus-container");

      if (isFnacPro) {
        this.$fnacPlusContainer.append(contentPro);
      }
      else {
        this.$fnacPlusContainer.append(contentCom);
      }

      this.isLoaded = true;
      // end
    },

    showContent: function () {
      if (!this.isLoaded) {
        this.initContent();
      }
      if (!this.isActive) {
        this.$fnacPlusContainer.addClass("is-active");
        this.isActive = true;
      }
    },

    removeContent: function () {
      this.$fnacPlusContainer.removeClass("is-active");
      this.isActive = false;
    },
  });
